import { render, staticRenderFns } from "./CabeceraModalEditar.vue?vue&type=template&id=af0e14ee&"
import script from "./CabeceraModalEditar.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalEditar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('af0e14ee', component.options)
    } else {
      api.reload('af0e14ee', component.options)
    }
    module.hot.accept("./CabeceraModalEditar.vue?vue&type=template&id=af0e14ee&", function () {
      api.rerender('af0e14ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/CabeceraModalEditar.vue"
export default component.exports